import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { Tenant } from '../../models';
import { OrganizationDataService, TenantDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { OrganizationForm } from './OrganizationForm';
import { PVAPage } from '../../components';

interface OrganizationCreateState {
    tenants: Tenant[];
}

export class OrganizationCreate extends React.Component<BaseRouteProps<{}>, OrganizationCreateState> {
    private organizationDataService = new OrganizationDataService(this.props.notificationService);
    private tenantDataService = new TenantDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            tenants: new Array<Tenant>()
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        this.tenantDataService.getAll().then((tenants: Tenant[]) => {
            this.setState({ tenants: tenants });
        });
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/organization`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Create Organization
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <OrganizationForm defaultValues={{}} submit={this.save} tenants={this.state.tenants} notificationService={this.props.notificationService} />
                </PVAPage.Body>
                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.organizationDataService.create(values).then((success) => {
            this.props.history.push(`/organization/${success.id}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/organization/OrganizationCreate.tsx